import { Link } from "react-router-dom";
import type { Movie } from "@/mocks/movies";
import { formatDate, getGenreLabel } from "@/lib/movie";
import ScoreBadge from "@/components/base/ScoreBadge";

interface MovieCardProps {
  movie: Movie;
  isFavorite?: boolean;
  onToggleFavorite?: (id: string) => void;
}

export default function MovieCard({ movie, isFavorite, onToggleFavorite }: MovieCardProps) {
  return (
    <div className="group relative">
      <Link to={`/detail/${movie.id}`} className="block cursor-pointer">
        <div className="relative w-full aspect-[2/3] rounded-lg overflow-hidden bg-background-200">
          <img
            src={movie.poster}
            alt={`${movie.title} 电影海报`}
            title={`${movie.title} - 最新电影资讯`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-primary-950/80 via-transparent to-transparent opacity-80"></div>
          <div className="absolute top-2.5 left-2.5">
            <ScoreBadge value={movie.rating} />
          </div>
          <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
            <span className="w-11 h-11 rounded-full bg-accent-500 flex items-center justify-center">
              <i className="ri-play-fill text-2xl text-background-50"></i>
            </span>
          </div>
          <div className="absolute bottom-2.5 left-2.5 right-2.5 flex flex-wrap gap-1">
            {movie.genres.slice(0, 2).map((g) => (
              <span
                key={g}
                className="text-[10px] px-1.5 py-0.5 rounded bg-background-50/90 text-foreground-800"
              >
                {getGenreLabel(g)}
              </span>
            ))}
          </div>
        </div>
        <div className="pt-3">
          <h3 className="text-[15px] font-semibold text-foreground-950 truncate group-hover:text-accent-600 transition-colors">
            {movie.title}
          </h3>
          <p className="text-xs text-foreground-500 mt-1">
            上映 {formatDate(movie.releaseDate)}
          </p>
        </div>
      </Link>
      {onToggleFavorite && (
        <button
          type="button"
          aria-label={isFavorite ? "取消收藏" : "收藏电影"}
          onClick={() => onToggleFavorite(movie.id)}
          className={`absolute top-2.5 right-2.5 w-8 h-8 flex items-center justify-center rounded-full backdrop-blur-sm transition-colors cursor-pointer ${
            isFavorite ? "bg-accent-500 text-background-50" : "bg-primary-950/50 text-background-100 hover:bg-primary-950/80"
          }`}
        >
          <i className={`${isFavorite ? "ri-heart-3-fill" : "ri-heart-3-line"} text-base`}></i>
        </button>
      )}
    </div>
  );
}